module.exports = __webpack_public_path__ + "5366eb72df47eb6c0af9face79398dad.jpg";